<template>
    <el-footer class="my_reglog_footer">
      <div  class="my_reglog_footer_path">
        <div style="width: 1920px;margin: auto;">
          <li class="my_reglog_footer_d">
            上海阅尔基因技术有限公司 沪公网安备31011002005278号 沪ICP备17045756号-2
          </li>
          <div style="margin-right: 200px">
            <li class="my_reglog_footer_f">
              Powered by WizInno
<!--              {{$t('footer.privacyPolicy')}}-->
            </li>
<!--            <li class="my_reglog_footer_f" style="margin-right: -5px;">-->
<!--              {{$t('footer.supplementaryTermsConditions')}} |-->
<!--            </li>-->
<!--            <li class="my_reglog_footer_f" style="margin-right: -5px;">-->
<!--              {{$t('footer.law')}} |-->
<!--            </li>-->
          </div>
        </div>
      </div>
    </el-footer>
</template>
<script>
  export default {
    name: 'footerNav',
    data () {
      return {

      }
    },
    methods: {


    },
    created(){

    },
    mounted() {
    }
  }
</script>
<style scoped>
.my_reglog_footer{
  height:75px !important;
  margin-top:0px;
  /*background: #00517D;*/
}
.my_reglog_footer div ul{
  /*width:60px;*/
  margin-left:180px;
  margin-top:60px;
  float: left;
}
.my_reglog_footer div ul li:first-child{
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 33px;
}
.my_reglog_footer div ul  li {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255,255,255,0.7);
  line-height: 28px;
  margin:16px 0;
}
.my_reglog_footer_path{
  height: 75px;
  margin: -95px auto;
}


.my_reglog_footer_d{
  width:930px;
  height: 34px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 34px;
  float: left;
  list-style-type: none;
  margin-top:25px;
  margin-left:180px;
  color: rgba(39,45,45,0.5);
}
.my_reglog_footer_f{
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(39,45,45,0.5);
  line-height: 28px;
  float: right;
  list-style-type: none;
  margin-top:25px;
  margin-left:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/log_reg_footer.vue